<template>
  <div class="header__greetings--agent">
    <div class="header__top">
      <button 
          @click="closeChat" 
          @keyup.enter="closeChat" 
          @keyup.space="closeChat" 
          :aria-label="$gettext('Cerrar chat')" 
          class="action-icon close" 
          tabindex="0"></button>
      <div class="header__agent">
        <div class="agent__avatar" v-if="(config && config.logo && logoExists) || (agent.avatar && avatarExists)">
          <img v-if="config && config.logo" :src="getFullLogoUrl(config.logo)" alt="Logotipo" class="header-logo" />
          <img v-else :src="agent.avatar" :alt="agent.name">
        </div>
        <div v-else class="agent__avatar default">
        </div>

        <div class="agent__data">
          <p 
              class="bold__greeting" 
              :title="$gettext('Tema del chat')"
              tabindex="0"
              v-if="config && config.primary_greeting">{{config.primary_greeting}}</p>
          <p 
              class="bold__greeting"
              :title="$gettext('Nombre del agente')"
              tabindex="0"
              v-else
              >{{ agent.name }}</p>
        </div>
      </div>
    </div>

    <div class="header-back">
      <button 
          ref="callIcon" 
          class="action-icon call" 
          @mouseenter="handleMouseEnter" 
          @mouseleave="handleMouseLeave" 
          v-if="isVideoCallAvailable && !this.isBanned && this.isVideoChatAvailable" 
          @click="CallFormTrue" 
          @keyup.enter="CallFormTrue" 
          tabindex="0"
          :aria-label="$gettext('Iniciar videoasistencia.')"
          :title="$gettext('Iniciar videollamada con tu agente')">
        </button>
      <div 
          class="action-icon call disabled" 
          tabindex="0"
          :title="$gettext('Videollamada no disponible')"
          v-else-if="this.call && this.threadState != 'closed'" 
          :aria-label="$gettext('Videollamada deshabilitada.')"><div class="call-active"></div> </div>
      <div v-if="showTooltip" ref="tooltip" class="tooltip" :style="tooltipStyle">{{$gettext('Iniciar videollamada con tu agente. Solo el agente compartirá imagen y pantalla.')}}</div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  props: ['agent', 'currentType'],
  data() {
    return {
      avatarExists: false,
      logoExists: false,
      showTooltip: false,
      tooltipStyle: {
        left: '0px',
        top: '0px'
      }
    };
  },
  methods: {
    ...mapMutations(["setChatOpen", "changeBounce", "showCallForm"]),
    ...mapActions(['closeCurrentChat']),
    closeChatWindow() {
      this.setChatOpen(false);
      this.changeBounce(false);
    },
    closeChat() {
      this.$emit('closeChat');
    },
    CallFormTrue(){
      this.showCallForm(true);
    },
    checkIfExist(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      });
    },
    handleMouseEnter() {
      this.showTooltip = true;
      this.$nextTick(() => {
        this.positionTooltip();
      });
    },
    handleMouseLeave() {
      this.showTooltip = false;
    },
    positionTooltip() {
      if (!this.$refs.callIcon || !this.$refs.tooltip) return;

      const iconRect = this.$refs.callIcon.getBoundingClientRect();
      const tooltipElement = this.$refs.tooltip;

      // Position tooltip below the icon, centered
      const left = iconRect.left + (iconRect.width / 2) - (tooltipElement.offsetWidth / 2);
      const top = iconRect.bottom + 8; // 8px gap below the icon

      // Ensure tooltip doesn't go off-screen horizontally
      const maxLeft = window.innerWidth - tooltipElement.offsetWidth - 10;
      const minLeft = 10;
      const finalLeft = Math.max(minLeft, Math.min(left, maxLeft));

      this.tooltipStyle = {
        left: `${finalLeft}px`,
        top: `${top}px`
      };

      // Adjust arrow position based on tooltip offset
      const arrowOffset = iconRect.left + (iconRect.width / 2) - finalLeft;
      tooltipElement.style.setProperty('--arrow-left', `${arrowOffset}px`);
    },
    getFullLogoUrl(logo) {
      // TODO revisar por que la url del .env no esta funcionando aqui
      // return this.baseLogosUrl+logo
      return `https://static.islas.ikea.es/assets/modules/pws/uploaded_files/logos/${logo}`;
    }
  },
  watch: {
    // Cuando cambia el avatar, se verifica si existe
    "agent.avatar": {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.checkIfExist(newVal).then((exists) => {
            this.avatarExists = exists;
          });
        }
      }
    },
    "config.logo": {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.checkIfExist(newVal).then((exists) => {
            this.logoExists = exists;
          });
        }
      }
    }
  },
  computed:{
    ...mapGetters(['threadState', 'config', 'baseLogosUrl']),
    ...mapState(['call', 'isWsActive', 'operatorGotCameraActive', 'isBanned', 'selectedGroupGotCamera', 'isVideoChatAvailable']),
    isVideoCallAvailable() {
      return !this.call && this.operatorGotCameraActive && this.threadState != 'closed' && this.selectedGroupGotCamera  // && !$device.isIOS;
    },
  }
}
</script>
<style>

</style>